import React from 'react'

import QATask from './qa-task'

export default ({
  qaTasks,
  onTaskComplete,
  onTaskUnable,

  hasNextPage,
  onLoadNextPage
}) => (
  <div className='list qa-task-list'>
    {qaTasks.map(task =>
      <QATask
        qaTask={task}
        key={task.id}
        onComplete={() => onTaskComplete(task.id)}
        onUnable={() => onTaskUnable(task.id)}
      />
    )}

    {hasNextPage &&
      <div className='card load-more' onClick={onLoadNextPage}>
        Load more...
      </div>}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/qa-tasks/qa-task-list.js